import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import Button from "../../components/Button";
import LieuFormFields from "./LieuFormFields";
import { useLieuDetail } from "../../../hooks/useLieuDetail";
import { useUpdateLieu } from "../../../hooks/useUpdateLieu";
import type { LieuDto } from "../../../api/lieuxApi";

export default function LieuEditPage() {
  const { id = "" } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const detail = useLieuDetail(id);
  const update = useUpdateLieu(id);
  const [draft, setDraft] = useState<LieuDto | null>(null);

  useEffect(() => {
    if (!detail.data) return;
    const l = detail.data;
    setDraft({
      name: l.name,
      description: l.description ?? "",
      addressName: l.addressName ?? "",
      address: {
        postcode: l.address?.postcode ?? "",
        city: l.address?.city ?? "",
        street: l.address?.street ?? "",
        latitude: l.address?.latitude,
        longitude: l.address?.longitude,
      },
      artistIds: (l.artists ?? []).map((a) => a.id),
    });
  }, [detail.data]);

  if (detail.isLoading) return <div className="bo-loading">Chargement…</div>;
  if (detail.isError || !detail.data)
    return <div className="bo-error-text" style={{ textAlign: "center" }}>Lieu introuvable.</div>;
  if (!draft) return null;

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    update.mutate(draft);
  };

  return (
    <form onSubmit={onSubmit}>
      <PageHeader
        title={detail.data.name}
        description="Modifier les informations du lieu, son adresse et les artistes qui y sont accueillis."
        actions={
          <Button type="button" variant="ghost" onClick={() => navigate("/admin/lieux")}>
            ← Tous les lieux
          </Button>
        }
      />
      <div className="bo-card">
        <LieuFormFields value={draft} onChange={setDraft} attachedArtists={detail.data.artists ?? []} />
      </div>
      <div style={{ marginTop: "var(--sp-5)", display: "flex", justifyContent: "flex-end" }}>
        <Button type="submit" variant="primary" loading={update.isPending}>
          Enregistrer
        </Button>
      </div>
      {update.isSuccess && <p className="bo-success-text">Lieu mis à jour.</p>}
      {update.isError && <p className="bo-error-text">Erreur : {(update.error as Error)?.message}</p>}
    </form>
  );
}
